import styled from 'styled-components';
import { getSizeInPx } from '../../methods/common.js';

const StyledShimmer = styled.div `
    width: 100%;
    height: ${({ height }) => { var _a; return (_a = getSizeInPx(height)) !== null && _a !== void 0 ? _a : "auto"; }};
    min-height: ${({ minHeight }) => { var _a; return (_a = getSizeInPx(minHeight)) !== null && _a !== void 0 ? _a : "120px"; }};
    border-radius: ${({ borderRadius }) => { var _a; return (_a = getSizeInPx(borderRadius)) !== null && _a !== void 0 ? _a : "16px"; }};
    background: linear-gradient(90deg, #eef2ff 25%, #e0e7ff 50%, #eef2ff 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;

    @keyframes shimmer {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
`;

export { StyledShimmer };
//# sourceMappingURL=Shimmer.styles.js.map
